// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Group, EntityList } from "../flow/types";
// import type {Action} from "../flow/types";

export default function(
  state: EntityList<Group> = initialState.groups,
  action: any
) {
  switch (action.type) {
    case ActionTypes.GET_GROUPS + ActionTypes.FULFILLED:
      var data = action.payload.data;
      const result: EntityList<Group> = new EntityList(
        data.result,
        data.totalPages
      );
      return result;
    default:
      return state;
  }
}
